import { Stack, Text, TableRow, TableCell } from 'braid-design-system';

import { SchemaMarkdown } from './SchemaMarkdown.tsx';
import { TypeLabel } from './TypeLabel.tsx';

import { NameLabel } from '#src/components/NameLabel/NameLabel.tsx';
import { NameTextLink } from '#src/components/NameTextLink/NameTextLink.tsx';
import { hrefForWebhookSchemaProperty } from '#src/utils/href.ts';
import type { AnyType } from '#src/utils/jsonSchema.ts';

interface Props {
  objectName?: string;
  name: string;
  type: AnyType;
  required?: boolean;
  highlight?: boolean;
  markdownPath: string;
}

export const PropertyDetails = ({
  objectName,
  name,
  type,
  required,
  highlight,
  markdownPath,
}: Props) => (
  <TableRow>
    <TableCell width="content">
      <Stack space="medium">
        {objectName ? (
          <NameTextLink
            name={name}
            required={required}
            highlight={highlight}
            to={hrefForWebhookSchemaProperty(objectName, name)}
            id={`${objectName}-${name}`}
            deprecated={false}
          />
        ) : (
          <NameLabel required={required}>{name}</NameLabel>
        )}
        <Text>
          <TypeLabel type={type} />
        </Text>
      </Stack>
    </TableCell>

    <TableCell wrap>
      <SchemaMarkdown type={markdownPath} />
    </TableCell>
  </TableRow>
);
